import { render, staticRenderFns } from "./RemolqueForm.vue?vue&type=template&id=65f188bf"
import script from "./RemolqueForm.vue?vue&type=script&lang=js"
export * from "./RemolqueForm.vue?vue&type=script&lang=js"
import style0 from "./RemolqueForm.vue?vue&type=style&index=0&id=65f188bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports